/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Trust_Human_ApprovesInputs */

const en_directory_agents_trust_human_approves = /** @type {(inputs: Directory_Agents_Trust_Human_ApprovesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing happens without you. The agent never sees your password — you approve every permission on seekai.dev itself.`)
};

const zh_directory_agents_trust_human_approves = /** @type {(inputs: Directory_Agents_Trust_Human_ApprovesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有你的同意什么都不会发生：agent 永远看不到你的密码，所有权限都在 seekai.dev 上由你勾选。`)
};

/**
* | output |
* | --- |
* | "Nothing happens without you. The agent never sees your password — you approve every permission on seekai.dev itself." |
*
* @param {Directory_Agents_Trust_Human_ApprovesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_trust_human_approves = /** @type {((inputs?: Directory_Agents_Trust_Human_ApprovesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Trust_Human_ApprovesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_trust_human_approves(inputs)
	return zh_directory_agents_trust_human_approves(inputs)
});
export { directory_agents_trust_human_approves as "directory.agents.trust_human_approves" }